import React, { useEffect, useState } from "react"
import {  TextArea, TextBox} from 'devextreme-react';
import DateBox from "../../../../common/CustomDateBox";
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/selectors";
import dayjs from "dayjs";
import { selectContract } from "../../../../../redux/contract/selectors";

function OvcForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const [type, setType] = useState(dataForm?.templateCode)
const contract = useSelector(selectContract);
const [company, setCompany] = useState(contract?.customerName)
useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))
    onChange("company", company)
    if(types && types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
        setType(types[0].id);
    }
    
},[])

useEffect(()=>{
    if(types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
        setType(types[0].id);
    }
},[types])

function changeDate(field, date){
    let stringDate = null; 
    if(date){
    stringDate = dayjs(date).format()
    }
    onChange(field,stringDate)
}

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

    return(
        <div className={classes.containers} id="documentation-request-form">
                <div className={"grid-two-columns"}>
                    <DateBox label={"Fecha y hora"} displayFormat={"dd/MM/yyyy HH:mm"} applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" value={dataForm?.date} onValueChanged={(e) => changeDate("date", e.value)}  ></DateBox>
                    <TextBox label={"DNI/CIF"} labelMode="floating"  key={"dni"} name="dni" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)}  ></TextBox> 
                </div>      
                    <TextBox label={"Empresa"} labelMode="floating"  key={"company"} name="company" value={company} onValueChanged={(e) =>{setCompany(e.value); onChange("company",e.value)}}  ></TextBox>
                <div className={"grid-two-columns"}>
                    <TextBox label={"Nome"} labelMode="floating"  key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)}  ></TextBox>
                    <TextBox label={"Apellidos"} labelMode="floating"  key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)}  ></TextBox>
                    <TextBox label={"Móvil"} labelMode="floating"  key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}}  ></TextBox>
                    <TextBox label={"Correo electrónico"} labelMode="floating"  key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)}  ></TextBox>                            
                </div>        
                    <TextArea label={"Motivo de contacto"} labelMode="floating" key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)}  height={144}></TextArea>
               
        </div>
    )
}

export { OvcForm }